import { useEffect, useState } from "react";

export const DeviceType = {
    Mobile:'mobile',
    Tablet:'tablet',
    PC:'PC',
};

export default function useRWD() {
    const [device, setDevice] = useState(DeviceType.Mobile);

    const handleRWD = () => {
        
        if (window.innerWidth >= 768) {
            setDevice(DeviceType.PC);
            
        } else if (window.innerWidth >=576) {
            setDevice(DeviceType.Tablet);
        } else {
            setDevice(DeviceType.Mobile);
        }
    }

    useEffect (() => {
        window.addEventListener("resize", handleRWD);
        handleRWD();
        return () => {
            window.removeEventListener("resize", handleRWD);
        }
    },[])

    return device

}